import { Box } from "@mui/system";
import { Grid, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const generateResult = (data) => {
  const result = data.map((item) => ({
    units_consumed: item.units_consumed / 1000,
    charger_type: `${item.charger_name}-${item.connector_id}`,
  }));
  let reducedArray = [];
  result.forEach((item) => {
    const index = reducedArray.findIndex(
      (value) => value.charger_type === item.charger_type
    );
    if (index < 0) reducedArray.push(item);
    else {
      reducedArray[index].units_consumed += item.units_consumed;
    }
  });
  reducedArray.sort((a, b) => {
    const nameA = a.charger_type.toUpperCase();
    const nameB = b.charger_type.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
  return reducedArray;
};

const ChargerUsageChart = ({ data }) => {
  const { selectedFacility } = useSelector((state) => state.stationList);
  const { selectedDate } = useSelector((state) => state.datePicker);

  const valueFormatter = (value) => `${value?.toFixed(2)} kWh`;

  const [results, setResults] = useState([
    { units_consumed: 0, charger_type: 0 },
  ]);

  useEffect(() => {
    if (data?.view_facility_revenue_aggregate?.nodes) {
      setResults(
        generateResult(
          data?.view_facility_revenue_aggregate?.nodes.filter(
            (item) => item.units_consumed
          )
        )
      );
    } else setResults([{ units_consumed: 0, charger_type: 0 }]);
  }, [data, selectedFacility, selectedDate]);

  return (
    <Box
      bgcolor={"white"}
      p={3}
      borderRadius={"16px"}
      padding={"24px 24px 8px"}
    >
      <Typography variant="subtitle" fontWeight="600">
        Charger Wise Usage
      </Typography>
      {results?.length > 0 && (
        <Grid container flexDirection="column">
          <Grid item display="flex">
            <Grid
              item
              display="flex"
              alignItems="center"
              sx={{ transform: "rotate(-90deg)", textAlign: "center" }}
              fontSize="12px"
              fontWeight="600"
              textTransform="uppercase"
            >
              Units Consumed
            </Grid>
            <BarChart
              dataset={results}
              xAxis={[{ dataKey: "charger_type", scaleType: "band" }]}
              yAxis={[{ dataKey: "units_consumed" }]}
              series={[
                { dataKey: "units_consumed", valueFormatter, color: "#467CEB" },
              ]}
              layout="vertical"
              height="230"
            />
          </Grid>
          <Grid
            item
            display="flex"
            justifyContent="center"
            fontSize="12px"
            fontWeight="600"
            textTransform="uppercase"
          >
            Charger Type
          </Grid>
        </Grid>
      )}
    </Box>
  );
};
export default ChargerUsageChart;
